import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

const pickerStyles = {
  textField: {
    variant: 'outlined',
    sx: {
      fontFamily: 'Trueno Light',
      backgroundColor: '#F0F0F0',
      borderRadius: '20px',
      width: '600px',

      // target the picker's own input root
      '& .MuiPickersOutlinedInput-root': {
        borderRadius: '20px',

        // default (transparent) outline
        '& fieldset': {
          borderColor: 'transparent',
          borderRadius: '20px',
        },
        // hover outline
        '&:hover fieldset': {
          borderColor: '#1EABF1',
        },
        // focused outline
        '&.Mui-focused fieldset': {
          borderColor: '#1EABF1',
        },
      },
    },
  },
}

export default function DateRangePicker({ value, setValue }) {
  return (
    <Stack spacing={2} width={600} direction="row" justifyContent="start">
      <Box
        width={250}
        sx={{
          fontSize: 16,
          fontFamily: "Montserrat Regular",
          alignSelf: "center",
          fontWeight: "bold",
        }}
      >
        Event Dates
      </Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          value={value.open}
          maxDateTime={value.close}
          onChange={(newValue) => {
            setValue({ ...value, open: newValue });
          }}
          slotProps={pickerStyles}
        />
      </LocalizationProvider>
      <Box
        sx={{
          fontSize: 15,
          fontFamily: "Montserrat Regular",
          alignSelf: "center",
        }}
      >
        to:
      </Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          value={value.close}
          minDateTime={value.open}
          onChange={(newValue) => {
            console.log(newValue);
            setValue({ ...value, close: newValue });
          }}
          slotProps={pickerStyles}
        />
      </LocalizationProvider>
    </Stack>
  );
}
